import { Pipe, PipeTransform, inject, Inject } from '@angular/core'
import { Environment, ENVIRONMENT } from '@wm-front/shared/environment'

export enum SalesforceWizardLinkSource {
  ADMIN = 'Admin',
}

export interface SalesforceWizardLinkConfiguration {
  source: SalesforceWizardLinkSource
  urlSuffix?: string
  parameters?: SalesforceWizardLinkParameter[]
}

export interface SalesforceWizardLinkParameter {
  data: string
  urlParameter: string
}

@Pipe({
  name: 'salesforceWizardLink',
  standalone: true,
})
export class SalesforceWizardLinkPipe implements PipeTransform {
  public env

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Inject(ENVIRONMENT) public _env?: Environment) {
    if (_env) {
      this.env = _env
    }
  }

  /**
   * Will transform the provided data into an url for the use of salesforce wizards
   * @returns {unknown}
   * @param config
   */
  public transform(config: SalesforceWizardLinkConfiguration): string {
    return this.buildUrl(config)
  }

  /**
   * Will build the url from the data
   * @param {SalesforceWizardLinkConfiguration} config
   * @returns {string}
   * @private
   */
  private buildUrl(config: SalesforceWizardLinkConfiguration): string {
    const url = new URL(`${this.env?.salesforceUrl}${config?.urlSuffix || ''}`)
    url.searchParams.append('c__quoteSource', config.source)
    config?.parameters?.forEach((param) =>
      url.searchParams.append(param.urlParameter, param.data)
    )
    return url.toString()
  }
}
